import GLU from '../glu2.js/src/index';

class MailHookApi extends GLU.Api {
  constructor(endpoint) {
    super(endpoint);

    this.createApiActions({
      name: 'emailNotification',
      method: GLU.Api.Post,
      path: '/mail_hook',
      credentials: true,
    });
  }
}

export default MailHookApi;
